export default __webpack_public_path__ + "static/media/bus.inline.e12e00db.svg";